import React from "react";
import ObserverEmitter, { EVENTS } from "../../emitter/Observer";
import { audiosAssets } from "../../assets/audio";

export const ModalInfo = ({ children, title = "", description = "", action = () => { } }) => {
	return (
		<div className="fixed z-30 bg-[#00000074] w-full h-full flex justify-center items-center">
			<div className="w-[352px] h-[240px] md:h-[384px] md:w-[484px] bg-[#F2F2F2] rounded-3xl p-4">
				<div className="h-[40px] py-1">
					<div className="w-full h-full bg-red_primary flex justify-center items-center rounded-md">
						<p className="text-white font-bold">{title}</p>
					</div>
				</div>
				<div className="h-[calc(100%-80px)] py-1">
					<div className="h-full w-full bg-white rounded-lg px-2 py-1 overflow-hidden md:px-4 md:py-4 overflow-y-scroll hidden-scrooll">
						{description !== "" ? (
							<p className="text-black font-light text-[11px] md:text-[16px]">{description}</p>
						) : (
							<>
								{children}
							</>
						)}
					</div>
				</div>
				<div className="h-[40px] py-1">
					<div onClick={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.barraNavegacion.completeNavigation)
						action()
					}} className="boxShadowButtons w-full h-full bg-yellow_primary flex justify-center items-center rounded-md">
						<p className="text-white font-bold">Continuar</p>
					</div>
				</div>
			</div>
		</div>
	);
};
